// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@kubb/plugin-client/clients/axios";
import type {
  ProcessStartProcessStartPostMutationRequest,
  ProcessStartProcessStartPostMutationResponse,
  ProcessStartProcessStartPost422,
} from "../models/undefinedController/ProcessStartProcessStartPost.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";

function getProcessStartProcessStartPostUrl() {
  const res = { method: "POST", url: `/process_start` as const };
  return res;
}

/**
 * @summary Process Start
 * {@link /process_start}
 */
export async function processStartProcessStartPost(
  data: ProcessStartProcessStartPostMutationRequest,
  config: Partial<
    RequestConfig<ProcessStartProcessStartPostMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    ProcessStartProcessStartPostMutationResponse,
    ResponseErrorConfig<ProcessStartProcessStartPost422>,
    ProcessStartProcessStartPostMutationRequest
  >({
    method: "POST",
    url: getProcessStartProcessStartPostUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
